import { atom } from "@mongez/react-atom";

export type DarkModeState = "light" | "dark";

export const darkModeAtom = atom<DarkModeState>({
  key: "darkMode",
  default: "light",
  beforeUpdate(newValue) {
    if (typeof window !== "undefined") {
      try {
        localStorage.setItem("dkm", newValue);
      } catch (error) {
        // localStorage is not available (privacy mode, iframe restrictions, etc.)
        // Continue without saving - dark mode will still work but won't persist
        console.warn("Failed to save dark mode preference:", error);
      }
    }
    return newValue;
  },
});

// Helper function to reset dark mode preferences (useful for testing)
export const resetDarkModePreferences = () => {
  if (typeof window !== "undefined") {
    try {
      localStorage.removeItem("dkm");
    } catch (error) {
      // localStorage is not available
      console.warn("Failed to reset dark mode preference:", error);
    }
  }
};
